import Listings from '../../../component/order/orderLisitng/Listings'

const OrderLisitng = () => {
  return (
    <Listings />
  )
}

export default OrderLisitng